import React from 'react';

import { Route, type RouteComponentProps, Switch } from 'react-router-dom';

import AgentEmbed from './AgentEmbed';
import CoreLayout from './CoreLayout';
import Directory from './Directory';
import TeamEmbed from './TeamEmbed';

// Embeddable Directory
const DirectoryRoute = () => (
	<CoreLayout>
		<Directory />
	</CoreLayout>
);

const AgentEmbedRoute = ({ match }: Pick<RouteComponentProps<{ agentId: string }>, 'match'>) => {
	return (
		<CoreLayout chromeless>
			<AgentEmbed match={match} />
		</CoreLayout>
	);
};

const TeamEmbedRoute = ({ match }: Pick<RouteComponentProps<{ teamId: string }>, 'match'>) => {
	return (
		<CoreLayout chromeless>
			<TeamEmbed match={match} />
		</CoreLayout>
	);
};

const AppRoutes = (): React.JSX.Element => {
	return (
		<Switch>
			<Route path="/people/agent/:agentId/embed" render={AgentEmbedRoute} />
			<Route path="/team/:teamId/embed" render={TeamEmbedRoute} />
			<Route path="(/.*)?" render={DirectoryRoute} />
		</Switch>
	);
};

export default AppRoutes;
